import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React, { useRef, useState } from 'react';
import { Box, Button, Typography } from '@mui/material';
import { ConfirmationDialog } from '../components';
import { fileToBase64 } from '../utils';
import imageCompression from 'browser-image-compression';
import { constants } from '../constants';
export function FileInputButtons({ setSettings, targetKey }) {
    const fileInputRef = useRef(null);
    const [isRemoveDialogOpen, setIsRemoveDialogOpen] = useState(false);
    // Determine accepted file types based on target
    const acceptedTypes = '.png,.jpg,.jpeg,.svg';
    const handleFileChange = async (e) => {
        const file = e.target.files?.[0];
        if (!file)
            return;
        let processedFile = file;
        // Compress raster images (PNG/JPG/JPEG) for both page images and logos
        if (['image/png', 'image/jpeg', 'image/jpg'].includes(file.type)) {
            try {
                const options = {
                    maxSizeMB: processedFile?.size / 3, // Target size (adjust as needed)
                    maxWidthOrHeight: 1000, // Resize dimensions
                    useWebWorker: true,
                    fileType: file.type, // Keep original format
                    preserveExif: false // Remove metadata to reduce size
                };
                processedFile = await imageCompression(file, options);
            }
            catch (err) {
                console.error('Compression error:', err);
                // Fall back to original file if compression fails
                processedFile = file;
            }
        }
        // Convert to Base64 (your existing function)
        const base64 = await fileToBase64(processedFile);
        setSettings((prev) => ({
            ...prev,
            [targetKey]: base64,
            [targetKey + '_file']: processedFile
        }));
    };
    const handleRemove = () => {
        setSettings((prev) => ({
            ...prev,
            [targetKey]: '',
            [targetKey + '_file']: ''
        }));
        setIsRemoveDialogOpen(false);
    };
    return (_jsxs(Box, { children: [_jsxs(Box, { sx: {
                    display: 'flex',
                    gap: '8px',
                    mb: 0.5,
                    mt: 1
                }, children: [_jsx("input", { ref: fileInputRef, accept: acceptedTypes, style: { display: 'none' }, type: "file", onChange: handleFileChange }), _jsx(Button, { variant: "contained", onClick: () => fileInputRef.current?.click(), children: constants.file_input_upload }), _jsx(Button, { variant: "outlined", onClick: () => setIsRemoveDialogOpen(true), color: "error", children: constants.file_input_remove }), _jsx(ConfirmationDialog, { bodyText: constants.file_input_remove_image_confirm_body, isOpen: isRemoveDialogOpen, setIsOpen: setIsRemoveDialogOpen, submitButtonText: constants.confirm, submitFunction: handleRemove })] }), _jsx(Typography, { variant: "body2", color: "#595959", children: constants.file_input_supported_formats_line })] }));
}
